export const initialImportResult = {
  status: 200,
  field: '',
  message: '',
  labelId: '',
  traceId: '',
  data: [],
  detailMsg: [],
};
